// useClipboard.js
import { useState, useCallback } from 'react';

const useClipboard = (timeout = 2000) => {
  const [isCopied, setIsCopied] = useState(false);
  const [error, setError] = useState(null);

  const copyToClipboard = useCallback(async (data, parseFunction) => {
    // Parse the data into a semicolon-separated string
    const text = typeof parseFunction === 'function'
      ? parseFunction(data)
      : data;

    try {
      // Modern Clipboard API (web + mobile browsers)
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);

      // Fallback for older browsers / mobile WebViews
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;

        // Prevent scrolling on iOS
        textarea.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
        document.body.appendChild(textarea);

        // iOS specific selection
        if (navigator.userAgent.match(/ipad|iphone/i)) {
          const range = document.createRange();
          range.selectNodeContents(textarea);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          textarea.setSelectionRange(0, 999999);
        } else {
          textarea.select();
        }

        const success = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (!success) throw new Error('execCommand copy failed');
      }

      setIsCopied(true);
      setError(null);
      setTimeout(() => setIsCopied(false), timeout);

    } catch (err) {
      setError(err.message);
      setIsCopied(false);
    }
  }, [timeout]);

  return { copyToClipboard, isCopied, error };
};

export default useClipboard;